import React, { useEffect, useState, useContext, useCallback } from 'react';
import { Button, Form, Popconfirm, Table, Select, Tag, InputNumber, Modal } from "antd";
import { getAssetCommonCodeList } from '../Common/api';
import axios from '../Common/axios.js';
import { assetColumnData } from './columns';
import { getAssetTypeValue } from '../Common/options.js';
import { getGridTableHeight } from '../Common/util';
import { excelDownload,csvDownload, EditableCell, EditableRow } from '../Common/function';
import AppContext from '../../components/AppContext';
import { TailSpin } from 'react-loader-spinner'
const { Option } = Select;

/** -------------------------------------------------------------------------- **/
const AssetTable = ({ data, companyCode, assetType, isLoading, onClickSaveHandler, selectedRowKeys, setSelectedRowKeys }) => {
    const myContext = useContext(AppContext);
    //console.log(myContext);

    // 변수 선언
    const [form] = Form.useForm();
    const [dataSource, setDataSource] = useState([]);
    const [deleteData, setDeleteData] = useState([]);
    const [onAssetTypeSelectOptions, setOnAssetTypeSelectOptions] = useState([]);
    const [assetTypeValue, setAssetTypeValue]  = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    let changeData = [];

    const [assetGradeHigh, setAssetGradeHigh] = useState(myContext.assetGradeHigh);  //7이상이면 High
    const [assetGradeRow, setAssetGradeRow] = useState(myContext.assetGradeRow);    //4이하이면 Row
    let onAssetTypeSelectOptions2 =[];
    
    // rowSelection 설정
    const rowSelection = {
        selectedRowKeys,
        onChange: (newSelectedRowKeys) => {
            setSelectedRowKeys(newSelectedRowKeys);
        },
    };
    
    useEffect(() => {
        document.addEventListener('touchstart', () => {}, { passive: true });
        setAssetTypeValue(getAssetTypeValue());
        return () => {
          document.removeEventListener('touchstart', () => {});
        };
      }, []);

    useEffect(() => {
        setDataSource(data);
        setDeleteData([]);
        setAssetGradeHigh(myContext.assetGradeHigh);
        setAssetGradeRow(myContext.assetGradeRow);
        setCurrentPage(1); // 데이터가 변경되면 첫 페이지로 이동
    }, [data]);
    
    useEffect(() => {
        // asset_spec 컬럼일 때만 데이터를 불러옴
            axios.get(getAssetCommonCodeList("asset_spec"))
            .then((response) => {

                if(response.data.totalCount == 0) {
                    Modal.info({text: "Error", value:"Error"});
                }
                
                // onAssetTypeSelectOptions2 = response.data.map((item, i) => {
                //     if(item.code_type == "asset_spec"){
                //         return { text: item.code_cd, value: item.code_cd, type:item.val_01 }
                //     }else return null;
                // });

                // console.log("onAssetTypeSelectOptions2", onAssetTypeSelectOptions2);
                // setOnAssetTypeSelectOptions(onAssetTypeSelectOptions2);

                setOnAssetTypeSelectOptions(response.data.map((item, i) => {
                    if(item.code_type == "asset_spec"){
                        return { text: item.code_cd, value: item.code_cd, type:item.val_01 }
                    }else return null;
                }));                
                
            })
            .catch((error) => {
                console.log("assettables --- 62 error");
                console.dir(error);
            }); 

    }, []);

    const defaultColumns = [
        {
            key: 'operation',
            width: '0px',
            defualt: '',
        },
        {
            title: 'delete',
            width: '100px',
            align: 'center',
            render: (_, record) =>
                dataSource.length >= 1 ? (
                    <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(record.id, record.asset_cd)}>
                        <a>Delete</a>
                    </Popconfirm>
                ) : null,
        },
    ];

    const columns = [...assetColumnData];
    
    // 자산 관리에 "삭제 필드"
    defaultColumns.map((col) => {
        columns.push(col);
    })

    // 자산 관리에 데이터 수정 가능하게 하는 코드"
    const mergedColumns = columns.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record) => ({
                record,
                editable: col.editable,
                dataIndex: col.dataIndex,
                title: col.title,
                handleSave,
            }),
        };
    });

    // 행 추가
    const handleAdd = () => {

        if (assetType == '') {
            Modal.info({ title: "한 행씩 추가하는 자산은 '자산구분'을 선택하고 '조회' 후 수행해야 합니다." });
            return;
        }

        // 자동으로 코드 값을 만들어 적용하는 분분
        // let test = dataSource.filter(d => d["asset_type"] === assetType);
        let len = dataSource.length;
        let maxValue = "";
        let newData = "";
        let os_type = assetTypeValue[assetType] ? assetTypeValue[assetType][2] : '-';

        if(len > 0 ){
            // dataSource.sort();
            // maxValue = dataSource[len-1]["asset_cd"];
            for (let i = 0; len > i; i++) {
                if (dataSource[i]["asset_type"] === assetType) {
                    maxValue = dataSource[i]["asset_cd"] > maxValue ? dataSource[i]["asset_cd"] : maxValue;
                }else{
                    // Modal.info({ title: "현재 자산구분과 같은 자산구분으로 선택되야 행추가가 가능합니다. \n또는 조회 버튼을 눌러주세요!" });
                    Modal.info({ title: "추가하려는 자산에 맞는 '자산구분'을 선택/조회 후 수행해야 합니다." });
                    return;
                }
            }

            const regex = /(.+?)([0-9]+)$/;
            let [, maxValueName, maxValueNumTemp] = maxValue.match(regex);
            let maxValueNumLen = maxValueNumTemp.length;
            let maxValueNum = Number(maxValueNumTemp) + 1;
            let zeroVal = maxValueNum.toString().padStart(maxValueNumLen, '0');
            let maxValueStr = maxValueName + zeroVal;

            // let zeroVal = maxValueNum > 99 ? "" : maxValueNum > 9 ? "0" : "00"; 
            // let maxValueStr = assetType+zeroVal+maxValueNum;
            let copyVal = dataSource[0];
            // os_ver 값을 설정합니다

            newData = {
                operation: 'C',
                id: 0,
                com_cd: companyCode,
                asset_type: copyVal.asset_type,
                asset_cd: maxValueStr,
                asset_nm: copyVal.asset_nm,
                asset_ip: '',
                // asset_spec : assetTypeValue[assetType][1],
                asset_spec: copyVal.asset_spec,
                asset_ver: '',
                asset_qty: 1,
                os_type: os_type,
                service_nm: copyVal.service_nm,
                depart_nm: copyVal.depart_nm,
                location_nm: copyVal.location_nm,
                manager_nm: copyVal.manager_nm,
                supervisor_nm: copyVal.supervisor_nm,
                isms_yn: copyVal.isms_yn,
                rms_yn: copyVal.rms_yn,
                use_yn: copyVal.use_yn,
                mac_no: '',
                ssh_port: '22',
                arch: '',
                cpu: '',
                confidential_score: copyVal.confidential_score,
                integrity_score: copyVal.availability_score,
                availability_score: copyVal.availability_score,
                asset_grd: copyVal.asset_grd,
                asset_rnk: copyVal.asset_rnk,

            };
        }else{
            maxValue = assetType+'001';
            newData = {
                operation: 'C',
                id: 0,
                com_cd: companyCode,
                asset_type: assetType,
                asset_cd: maxValue,
                asset_nm: '',
                asset_ip: '',
                asset_spec : onAssetTypeSelectOptions.filter((item) => item.type == assetType)[0].text,
                // asset_spec : assetTypeValue[assetType][1],
                asset_ver: '',
                asset_qty: 1,
                os_type: os_type,
                service_nm: '',
                depart_nm: '',
                location_nm: '',
                manager_nm: '',
                supervisor_nm: '',
                isms_yn: 'Y',
                rms_yn: 'Y',
                use_yn: 'Y',
                mac_no: '',
                ssh_port: '22',
                arch: '',
                cpu: '',
                confidential_score: 3,
                integrity_score: 3,
                availability_score: 3,
                asset_grd: 'H',
                asset_rnk: 3,
            }   
        }

        const newDataSource = [...dataSource, newData];
        setDataSource(newDataSource);
        const lastPage = Math.ceil(newDataSource.length / pageSize);
        setCurrentPage(lastPage);

        newData={};
    };


    // // 행 삭제
    // const handleDelete = (key) => {
    //     const newData = dataSource.filter((item) => item.id != key);
    //     setDataSource(newData);

    //     if (key != 0) {
    //         const delData = dataSource.filter((item) => item.id == key);
    //         delData[0].operation = 'D';
    //         setDeleteData(deleteData.concat(delData));
    //     }
    // };

    // 행 삭제
    const handleDelete = (key, asset_cd) => {

        const newData = dataSource.filter((item) => item.asset_cd != asset_cd);
        setDataSource(newData);

        if (key != 0) {
            // const delData = dataSource.filter((item) => item.id == key);
            const delData = dataSource.filter((item) => item.asset_cd == asset_cd);
            delData[0].operation = 'D';
            setDeleteData(deleteData.concat(delData));
        }
    };

    // 선택된 항목 삭제
    const handleDeleteSelected = () => {
        const newData = dataSource.filter((item) => !selectedRowKeys.includes(item.asset_cd));
        const delData = dataSource.filter((item) => selectedRowKeys.includes(item.asset_cd) && item.id !== '0');
        
        // 삭제 대상에 operation 'D' 추가
        const deletedItems = delData.map(item => ({
            ...item,
            operation: 'D'
        }));
        
        setDataSource(newData);
        setDeleteData(deleteData.concat(deletedItems));
        setSelectedRowKeys([]);
    };

    //행 저장
    const handleSave = (row) => {
        //비교를 위하여 깊은 복사 실행
        const newData = JSON.parse(JSON.stringify(dataSource));
        const index = newData.findIndex((item) => row.asset_cd === item.asset_cd);
        const item = newData[index];
        //보안등급, 자산평가 계산
        let confidential = row.confidential_score ? parseInt(row.confidential_score) : 0;
        let integrity = row.integrity_score ? parseInt(row.integrity_score) : 0;
        let availability = row.availability_score ? parseInt(row.availability_score) : 0;
        let score_sum = confidential + integrity + availability;

        if (score_sum >= assetGradeHigh) {
            row.asset_grd = 'H';
            row.asset_rnk = 3;
        } else if (score_sum > assetGradeRow) {
            row.asset_grd = 'M';
            row.asset_rnk = 2;
        } else {
            row.asset_grd = 'L';
            row.asset_rnk = 1;
        }

        if (JSON.stringify(item) != JSON.stringify(row)) {
            row.operation = row.id == '0' ? 'C' : 'U';
            newData.splice(index, 1, {
                ...item,
                ...row,
            });
            setDataSource(newData);
        }
    };

    useEffect(() => {
        //저장,수정 대상 추가
        const newData = dataSource.filter((item) => item.operation && item.operation != '');
        changeData = [];
        newData.map((record) => {
            if (record.operation && record.operation != '') {
                changeData = changeData.concat(record);
            }
        });
    }, [dataSource]);


    // 보안등급 변경
    const onChangeGradeHigh = (value) => {
        setAssetGradeHigh(value);
    };
    const onChangeGradeRow = (value) => {
        setAssetGradeRow(value);
    };
    
    //보안등급 재설정
    const handleGrade = () => {
        dataSource.map((row) => {
            handleSave(row);
            //재계산 처리시에 적용함
            myContext.setAssetGradeHigh(assetGradeHigh);
            myContext.setAssetGradeRow(assetGradeRow);
        })
        Modal.info({ title: "변경된 등급은 Save를 클릭해야만 DB에 저장됩니다.", okText: "Close" });
    }


    // const observer = new PerformanceObserver((list) => {
    //     const relevantEntries = list.getEntries().filter(entry => 
    //         entry.entryType === 'event' && 
    //         ['click', 'keydown', 'touchstart'].includes(entry.name) &&
    //         entry.processingEnd - entry.startTime > 16 // 16ms 이상만
    //     );
        
    //     relevantEntries.forEach(entry => {
    //         const inp = entry.processingEnd - entry.startTime;
    //         console.log('INP:', inp.toFixed(2), 'ms');
    //     });
    // });
    // observer.observe({ entryTypes: ['event'] });
    // 보안등급 재설정
    // const handleGrade = useCallback(() => {
    //     const updatedDataSource = dataSource.map((row) => {
    //         return handleSave(row);
    //     });
    //     setDataSource(updatedDataSource);

    //     // 재계산 처리시에 적용함
    //     myContext.setAssetGradeHigh(assetGradeHigh);
    //     myContext.setAssetGradeRow(assetGradeRow);

    //     Modal.info({ title: "변경된 등급은 Save를 클릭해야만 DB에 저장됩니다.", okText: "닫기" });
    // }, [dataSource, assetGradeHigh, assetGradeRow, myContext, handleSave]);
    
    // const TailSpins = (<TailSpin height="100" width="100%" color="#4fa94d" ariaLabel="tail-spin-loading" radius="2" wrapperStyle={{}} wrapperClass="" visible={true} />);
    return (
        <>
            <table style={{ width: '100%' }}><tbody>
                <tr>
                    <td><div style={{ marginLeft: '20px' }}>총 {dataSource?.length} 개</div></td>
                    <td style={{ textAlign: 'right' }}>
                        {/* <span style={{ color: '#0378c7', paddingRight: '20px' }}>
                            ※ 여기서는 엑셀 파일 자료만 등록 가능합니다. 
                            자산을 추가, 수정, 삭제하고 싶으시면 <span style={{ color: 'red  '}}> "취약점 분석" </span> 메뉴로 이동해 사용해 주세요!
                        </span> */}
                        
                        <span style={{ color: '#0378c7', paddingRight: '20px' }}>※ 보안등급 : 기밀성+무결성+가용성 합계에 의하여 세팅됨.
                            &nbsp;&nbsp;&nbsp;
                            <Tag color={'volcano'}>High</Tag>
                            <InputNumber min={1} max={9} value={assetGradeHigh} size={'small'} style={{ width: '50px' }} disabled />이상
                            {/* <InputNumber min={1} max={9} value={assetGradeHigh} size={'small'} style={{ width: '50px' }} onChange={onChangeGradeHigh} />이상 */}
                            &nbsp;&nbsp;
                            &nbsp;&nbsp;
                            <Tag color={'green'}>Low</Tag>
                            <InputNumber min={1} max={9} value={assetGradeRow} size={'small'} style={{ width: '50px' }} disabled />이하
                            {/* <InputNumber min={1} max={9} value={assetGradeRow} size={'small'} style={{ width: '50px' }} onChange={onChangeGradeRow} />이하 */}
                            {/* &nbsp;&nbsp;
                            <Button type="default" onClick={() => handleGrade()}>
                                보안등급 재설정
                            </Button> */}
                        </span> 

                        <Button type="default" onClick={() => handleAdd()}>
                            Add a row
                        </Button>
                        {selectedRowKeys && selectedRowKeys.length > 0 && (
                            <Popconfirm 
                                title={`선택한 ${selectedRowKeys.length}개의 자산을 삭제하시겠습니까?`}
                                onConfirm={() => handleDeleteSelected()}
                            >
                                <Button type="default" danger style={{marginLeft: '5px'}}>
                                    선택 삭제 ({selectedRowKeys.length}개)
                                </Button>
                            </Popconfirm>
                        )}
                        <Button type="primary" onClick={() => onClickSaveHandler(changeData.concat(deleteData))}>
                            Save
                        </Button>
                        {/* <Button type="default" onClick={() => excelDownload('자산목록', dataSource)}> */}
                        <Button type="default" onClick={() => csvDownload('자산목록', dataSource)}>
                            {/* Excel Download */}
                            CSV Download
                        </Button>
                    </td>
                </tr></tbody>
            </table>

            <Form form={form} component={false}>
                <Table
                    columns={mergedColumns}
                    // columns={columns}
                    // rowKey="id"
                    rowKey="asset_cd"
                    dataSource={dataSource}
                    rowSelection={rowSelection}
                    scroll={{ y: getGridTableHeight(380) }}
                    style={{ height: getGridTableHeight(380)}}
                    // loading={isLoading ? { indicator: TailSpins } : false}
                    loading={{
                        size: "large",
                        spinning: isLoading
                      }}
                    // pagination={false}
                    pagination={{
                        current: currentPage,
                        pageSize: pageSize,
                        total: dataSource.length,
                        showSizeChanger: true,
                        pageSizeOptions: ['20', '50', '100'],
                        showTotal: (total) => `총 ${total}개`,
                        position: ['bottomCenter'], 
                        onChange: (page, size) => {
                            setCurrentPage(page);
                            setPageSize(size);
                        },
                    }}
                    bordered size={"small"}
                    showSorterTooltip={false}
                    components={{
                        body: {
                            row: EditableRow,
                            // cell: EditableCell,
                            cell: (props) => (
                                <EditableCell 
                                    {...props} 
                                    onAssetTypeSelectOptions={onAssetTypeSelectOptions}
                                />
                            ),
                        },
                    }}
                />
            </Form>
        </>
    );
}
export default AssetTable;